import React from 'react';
import FlowStepper from '@Local/Components/FlowStepper';

/** 兌換流程步驟條。由各頁以 setHeaderContent 塞進 Header 插槽，給 onBack 才顯示返回鈕。 */
const REDEEM_STEPS = ['選擇商品', '確認兌換'];

const RedeemStepper = ({ activeStep = 0, onBack }) => (
    <FlowStepper steps={REDEEM_STEPS} activeStep={activeStep} onBack={onBack} />
);

export default RedeemStepper;
